import React from "react";
import PhaseReadingChart from "./PhaseReadingChart";
import { images } from "../../common/images";

const TEMPERATURE_DECIMALS = { axis: 0, tooltip: 1 };
// Read from the temperature logs; below -50 is the sensor's error value, not
// a temperature.
const TEMPERATURE_SERIES = { logs: "temperatureLogs", valid: (t) => t >= -50 };

export default function TemperatureLineChart({ selectedDeviceSelectedDayData }) {
  return (
    <PhaseReadingChart
      selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      reading="t"
      name="Temperature"
      image={images.temperature}
      iconBackgroundColor="rgba(50, 47, 200, 0.10)"
      unit="°C"
      axisTitle="Celsius (°C)"
      fromZero
      decimals={TEMPERATURE_DECIMALS}
      seriesOptions={TEMPERATURE_SERIES}
    />
  );
}
